/**
 * TrofeiSquadra — mostra le medaglie dei trofei vinti dalla squadra nella
 * ultima stagione CONCLUSA (campione in carica + CL + Supercoppa).
 *
 * Sparisce se nessuna stagione conclusa o se la squadra non ha vinto nulla.
 * Usato accanto al nome della squadra in classifica, rosa, dashboard.
 */

import { usePalmaresUltimaConclusa } from "../../hooks/useStagione";
import { useSquadCupVinte } from "../../hooks/useSquadCup";
import { tr } from "../../i18n";

interface TrofeiSquadraProps {
  squadraId: string;
  /** Dimensione delle icone (default "sm" = inline accanto al nome). */
  size?: "sm" | "md";
  className?: string;
}

export function TrofeiSquadra({ squadraId, size = "sm", className = "" }: TrofeiSquadraProps) {
  const { data: palmares } = usePalmaresUltimaConclusa();
  // Andrea 2026-10-08: la SquadCup va in bacheca (niente toppa sulla maglia)
  const { data: squadcup } = useSquadCupVinte();

  const trofei: { emoji: string; label: string }[] = [];
  if (palmares?.campionato_squadra_id === squadraId)
    trofei.push({ emoji: "🏆", label: tr("Campione {{v1}}", { v1: palmares.anno }) });
  if (palmares?.cl_squadra_id === squadraId)
    trofei.push({
      emoji: "⭐",
      label: tr("{{v1}} {{v2}}", { v1: palmares.cl_nome ?? "Coppa", v2: palmares.anno }),
    });
  if (palmares?.supercoppa_squadra_id === squadraId)
    trofei.push({ emoji: "👑", label: tr("Supercoppa {{v1}}", { v1: palmares.anno }) });
  for (const v of squadcup ?? []) {
    if (v.squadra_id === squadraId) trofei.push({ emoji: "🦅", label: v.edizione_nome });
  }

  if (trofei.length === 0) return null;

  const sizeClass = size === "md" ? "text-lg" : "text-sm";
  return (
    <span className={`inline-flex items-center gap-0.5 ${sizeClass} ${className}`}>
      {trofei.map((t) => (
        <span key={t.label} title={t.label} aria-label={t.label}>
          {t.emoji}
        </span>
      ))}
    </span>
  );
}
